import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
//import { toast } from 'react-toastify';

axios.defaults.baseURL = "https://mrolserver.shahal.co.il/api";
//axios.defaults.baseURL = "https://localhost:7086/api";

const tokenKey = "token";
axios.interceptors.response.use(null, (error) => {
  if (!error.response || !error.response.data) {
    toast.error(" לא מצליח להתחבר לשרת  ");
    return;
  }

  if (error.response.status === 401) {
    console.log(" לוגין פג תוקף  ");
    // window.location.replace('/logout');
  }
  if (error.response.status === 400) {
    if (error.response.data !== "WrongPassword") {
      toast.error(error.response.data);
    } else {
      toast.error("שגיאה בנתוני התחברות");
    }
  }
  const expectedError =
    error.response &&
    error.response.status > 401 &&
    error.response.status < 500;
  if (expectedError) {
    toast.error("Unexpected Error ! " + error.response.status.toString());
    alert("Unexpected Error ! " + error.response.status.toString());
  }
  return Promise.reject(error);
});

function seJwt(jwt) {
  axios.defaults.headers.common["Authorization"] = jwt;
}

export function RenewLogin(headers) {
  if (headers && headers["x-auth-token"] && headers["x-auth-token"] !== "") {
    seJwt(headers["x-auth-token"]);
    localStorage.setItem(tokenKey, headers["x-auth-token"]);
  }
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  seJwt,
  RenewLogin,
};
